module.exports = __webpack_public_path__ + "img/integrated-cable-start.53655e05.svg";